<template>
  <template v-if="showHeader">
    <template v-if="lineLayout == 'Compact'">
      <div class="navbar justify-content-start layout-2">
        <div>
          <img
            :src="$store.state.domain + $store.state.theme.themeLogoLine"
            class="logo-img"
            @click="toProfile"
          />
        </div>
        <div
          class="lang-icon"
          v-if="$route.path == '/validatetelephone' && languageList.length > 1"
        >
          <v-menu location="bottom">
            <template v-slot:activator="{ props }">
              <c-btn
                flat
                :ripple="false"
                type="icon"
                v-bind="props"
                variant="text"
              >
                <svg
                  width="60"
                  height="30"
                  viewBox="0 0 60 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="30"
                    cy="30"
                    r="30"
                    fill="white"
                    fill-opacity="0.2"
                  />
                  <g clip-path="url(#clip0_4236_5179)">
                    <path
                      d="M34.5625 25.5C34.5625 26.6707 34.4992 27.7992 34.3885 28.875H24.6168C24.5008 27.7992 24.4428 26.6707 24.4428 25.5C24.4428 24.3293 24.5061 23.2008 24.6168 22.125H34.3885C34.5045 23.2008 34.5625 24.3293 34.5625 25.5ZM36.0812 22.125H42.5729C42.8523 23.2061 43 24.3346 43 25.5C43 26.6654 42.8523 27.7939 42.5729 28.875H36.0812C36.192 27.7887 36.25 26.6602 36.25 25.5C36.25 24.3398 36.192 23.2113 36.0812 22.125ZM42.0191 20.4375H35.865C35.3377 17.0678 34.2936 14.2465 32.9488 12.443C37.0779 13.5346 40.4371 16.5299 42.0139 20.4375H42.0191ZM34.1564 20.4375H24.8436C25.1652 18.518 25.6609 16.8199 26.2674 15.4436C26.8211 14.199 27.4381 13.2973 28.034 12.7277C28.6246 12.1687 29.115 12 29.5 12C29.885 12 30.3754 12.1687 30.966 12.7277C31.5619 13.2973 32.1789 14.199 32.7326 15.4436C33.3443 16.8146 33.8348 18.5127 34.1564 20.4375ZM23.135 20.4375H16.9809C18.5629 16.5299 21.9168 13.5346 26.0512 12.443C24.7064 14.2465 23.6623 17.0678 23.135 20.4375ZM16.4271 22.125H22.9187C22.808 23.2113 22.75 24.3398 22.75 25.5C22.75 26.6602 22.808 27.7887 22.9187 28.875H16.4271C16.1477 27.7939 16 26.6654 16 25.5C16 24.3346 16.1477 23.2061 16.4271 22.125ZM26.2674 35.5512C25.6557 34.1801 25.1652 32.482 24.8436 30.5625H34.1564C33.8348 32.482 33.3391 34.1801 32.7326 35.5512C32.1789 36.7957 31.5619 37.6975 30.966 38.267C30.3754 38.8313 29.885 39 29.5 39C29.115 39 28.6246 38.8313 28.034 38.2723C27.4381 37.7027 26.8211 36.801 26.2674 35.5564V35.5512ZM23.135 30.5625C23.6623 33.9322 24.7064 36.7535 26.0512 38.557C21.9168 37.4654 18.5629 34.4701 16.9809 30.5625H23.135ZM42.0191 30.5625C40.4371 34.4701 37.0832 37.4654 32.9541 38.557C34.2988 36.7535 35.3377 33.9322 35.8703 30.5625H42.0244H42.0191Z"
                      fill="var(--primary-color)"
                    />
                  </g>
                  <path
                    d="M19.07 42.969H17.216V42.204H21.896V42.969H20.051V48H19.07V42.969ZM22.6822 42.204H23.6632V44.724H26.4532V42.204H27.4342V48H26.4532V45.48H23.6632V48H22.6822V42.204ZM30.4969 42.042H31.4959L29.3899 48H28.3909L30.4969 42.042ZM32.4469 42.204H36.4879V42.969H33.4279V44.724H36.1549V45.48H33.4279V47.244H36.4879V48H32.4469V42.204ZM37.3951 42.204H38.2591L41.2831 46.47V42.204H42.2551V48H41.3911L38.3761 43.743V48H37.3951V42.204Z"
                    fill="var(--primary-color)"
                  />
                  <defs>
                    <clipPath id="clip0_4236_5179">
                      <rect
                        width="27"
                        height="27"
                        fill="white"
                        transform="translate(16 12)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </c-btn>
            </template>

            <v-list>
              <template v-for="lang of languageList" :key="'lang' + lang.id">
                <v-list-item @click="changeLang(lang.id)" link-class="px-3">
                  <div class="d-flex align-items-center px-3">
                    <span class="flag-lang mr-2"> {{ lang.image_url }} </span>
                    <span data-lang="profile">{{ lang.display_name }}</span>
                    <span v-if="lang.id == langs.lang" class="ml-auto">
                      <font-awesome-icon icon="check" />
                    </span>
                  </div>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </div>
      </div>
    </template>
    <template v-else-if="hideLogoImg && $isMinimalProfile">
      <div
        data-lang="navbar"
        class="navbar layout-1 justify-content-center relative"
        :class="{ blank: isShowing }"
      >
        <div v-if="$route.path == '/profile'" class="f-md">My Profile</div>
        <img
          v-else
          :src="$store.state.domain + $store.state.theme.themeLogoLine"
          class="logo-img"
          @click="toProfile"
        />
        <!-- -->
        <!--  -->

        <div class="lang-icon" v-if="languageList.length > 1">
          <v-menu location="bottom">
            <template v-slot:activator="{ props }">
              <c-btn
                flat
                :ripple="false"
                type="icon"
                v-bind="props"
                variant="text"
              >
                <svg
                  width="100"
                  height="30"
                  viewBox="0 0 60 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="30"
                    cy="30"
                    r="30"
                    fill="white"
                    fill-opacity="0.2"
                  />
                  <g clip-path="url(#clip0_4236_5179)">
                    <path
                      d="M34.5625 25.5C34.5625 26.6707 34.4992 27.7992 34.3885 28.875H24.6168C24.5008 27.7992 24.4428 26.6707 24.4428 25.5C24.4428 24.3293 24.5061 23.2008 24.6168 22.125H34.3885C34.5045 23.2008 34.5625 24.3293 34.5625 25.5ZM36.0812 22.125H42.5729C42.8523 23.2061 43 24.3346 43 25.5C43 26.6654 42.8523 27.7939 42.5729 28.875H36.0812C36.192 27.7887 36.25 26.6602 36.25 25.5C36.25 24.3398 36.192 23.2113 36.0812 22.125ZM42.0191 20.4375H35.865C35.3377 17.0678 34.2936 14.2465 32.9488 12.443C37.0779 13.5346 40.4371 16.5299 42.0139 20.4375H42.0191ZM34.1564 20.4375H24.8436C25.1652 18.518 25.6609 16.8199 26.2674 15.4436C26.8211 14.199 27.4381 13.2973 28.034 12.7277C28.6246 12.1687 29.115 12 29.5 12C29.885 12 30.3754 12.1687 30.966 12.7277C31.5619 13.2973 32.1789 14.199 32.7326 15.4436C33.3443 16.8146 33.8348 18.5127 34.1564 20.4375ZM23.135 20.4375H16.9809C18.5629 16.5299 21.9168 13.5346 26.0512 12.443C24.7064 14.2465 23.6623 17.0678 23.135 20.4375ZM16.4271 22.125H22.9187C22.808 23.2113 22.75 24.3398 22.75 25.5C22.75 26.6602 22.808 27.7887 22.9187 28.875H16.4271C16.1477 27.7939 16 26.6654 16 25.5C16 24.3346 16.1477 23.2061 16.4271 22.125ZM26.2674 35.5512C25.6557 34.1801 25.1652 32.482 24.8436 30.5625H34.1564C33.8348 32.482 33.3391 34.1801 32.7326 35.5512C32.1789 36.7957 31.5619 37.6975 30.966 38.267C30.3754 38.8313 29.885 39 29.5 39C29.115 39 28.6246 38.8313 28.034 38.2723C27.4381 37.7027 26.8211 36.801 26.2674 35.5564V35.5512ZM23.135 30.5625C23.6623 33.9322 24.7064 36.7535 26.0512 38.557C21.9168 37.4654 18.5629 34.4701 16.9809 30.5625H23.135ZM42.0191 30.5625C40.4371 34.4701 37.0832 37.4654 32.9541 38.557C34.2988 36.7535 35.3377 33.9322 35.8703 30.5625H42.0244H42.0191Z"
                      fill="var(--primary-color)"
                    />
                  </g>
                  <path
                    d="M19.07 42.969H17.216V42.204H21.896V42.969H20.051V48H19.07V42.969ZM22.6822 42.204H23.6632V44.724H26.4532V42.204H27.4342V48H26.4532V45.48H23.6632V48H22.6822V42.204ZM30.4969 42.042H31.4959L29.3899 48H28.3909L30.4969 42.042ZM32.4469 42.204H36.4879V42.969H33.4279V44.724H36.1549V45.48H33.4279V47.244H36.4879V48H32.4469V42.204ZM37.3951 42.204H38.2591L41.2831 46.47V42.204H42.2551V48H41.3911L38.3761 43.743V48H37.3951V42.204Z"
                    fill="var(--primary-color)"
                  />
                  <defs>
                    <clipPath id="clip0_4236_5179">
                      <rect
                        width="27"
                        height="27"
                        fill="white"
                        transform="translate(16 12)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </c-btn>
            </template>

            <v-list>
              <template v-for="lang of languageList" :key="'lang' + lang.id">
                <v-list-item @click="changeLang(lang.id)" link-class="px-3">
                  <div class="d-flex align-items-center px-3">
                    <span class="flag-lang mr-2"> {{ lang.image_url }} </span>
                    <span data-lang="profile">{{ lang.display_name }}</span>
                    <span v-if="lang.id == langs.lang" class="ml-auto">
                      <font-awesome-icon icon="check" />
                    </span>
                  </div>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </div>
      </div>
    </template>
    <template
      v-else-if="
        hideLogoImg && ($isShowTab || $isMinimalCompact || $isMinimalMinibar)
      "
    >
      <div class="lang-icon" v-if="languageList.length > 1">
        <v-menu location="bottom">
          <template v-slot:activator="{ props }">
            <c-btn
              flat
              :ripple="false"
              type="icon"
              v-bind="props"
              variant="text"
            >
            </c-btn>
          </template>

          <v-list>
            <template v-for="lang of languageList" :key="'lang' + lang.id">
              <v-list-item @click="changeLang(lang.id)" link-class="px-3">
                <div class="d-flex align-items-center px-3">
                  <span class="flag-lang mr-2"> {{ lang.image_url }} </span>
                  <span data-lang="profile">
                    {{ lang.display_name }} {{ hideLogoImg }}
                  </span>
                  <span v-if="lang.id == langs.lang" class="ml-auto">
                    <font-awesome-icon icon="check" />
                  </span>
                </div>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </div>
    </template>
    <template v-else>
      <div class="navbar layout-1 justify-content-center relative">
        <!-- :class="{ blank: isShowing }" -->
        <img
          :src="
            isStamp
              ? require('@/assets/images/stamp/event-logo.png')
              : $store.state.domain + $store.state.theme.themeLogoLine
          "
          class="logo-img"
          @click="toProfile"
        />
        <!-- -->
        <!--  -->

        <div class="lang-icon" v-if="languageList.length > 1">
          <v-menu location="bottom">
            <template v-slot:activator="{ props }">
              <c-btn
                flat
                :ripple="false"
                type="icon"
                v-bind="props"
                variant="text"
              >
                <svg
                  width="100"
                  height="30"
                  viewBox="0 0 60 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="30"
                    cy="30"
                    r="30"
                    fill="white"
                    fill-opacity="0.2"
                  />
                  <g clip-path="url(#clip0_4236_5179)">
                    <path
                      d="M34.5625 25.5C34.5625 26.6707 34.4992 27.7992 34.3885 28.875H24.6168C24.5008 27.7992 24.4428 26.6707 24.4428 25.5C24.4428 24.3293 24.5061 23.2008 24.6168 22.125H34.3885C34.5045 23.2008 34.5625 24.3293 34.5625 25.5ZM36.0812 22.125H42.5729C42.8523 23.2061 43 24.3346 43 25.5C43 26.6654 42.8523 27.7939 42.5729 28.875H36.0812C36.192 27.7887 36.25 26.6602 36.25 25.5C36.25 24.3398 36.192 23.2113 36.0812 22.125ZM42.0191 20.4375H35.865C35.3377 17.0678 34.2936 14.2465 32.9488 12.443C37.0779 13.5346 40.4371 16.5299 42.0139 20.4375H42.0191ZM34.1564 20.4375H24.8436C25.1652 18.518 25.6609 16.8199 26.2674 15.4436C26.8211 14.199 27.4381 13.2973 28.034 12.7277C28.6246 12.1687 29.115 12 29.5 12C29.885 12 30.3754 12.1687 30.966 12.7277C31.5619 13.2973 32.1789 14.199 32.7326 15.4436C33.3443 16.8146 33.8348 18.5127 34.1564 20.4375ZM23.135 20.4375H16.9809C18.5629 16.5299 21.9168 13.5346 26.0512 12.443C24.7064 14.2465 23.6623 17.0678 23.135 20.4375ZM16.4271 22.125H22.9187C22.808 23.2113 22.75 24.3398 22.75 25.5C22.75 26.6602 22.808 27.7887 22.9187 28.875H16.4271C16.1477 27.7939 16 26.6654 16 25.5C16 24.3346 16.1477 23.2061 16.4271 22.125ZM26.2674 35.5512C25.6557 34.1801 25.1652 32.482 24.8436 30.5625H34.1564C33.8348 32.482 33.3391 34.1801 32.7326 35.5512C32.1789 36.7957 31.5619 37.6975 30.966 38.267C30.3754 38.8313 29.885 39 29.5 39C29.115 39 28.6246 38.8313 28.034 38.2723C27.4381 37.7027 26.8211 36.801 26.2674 35.5564V35.5512ZM23.135 30.5625C23.6623 33.9322 24.7064 36.7535 26.0512 38.557C21.9168 37.4654 18.5629 34.4701 16.9809 30.5625H23.135ZM42.0191 30.5625C40.4371 34.4701 37.0832 37.4654 32.9541 38.557C34.2988 36.7535 35.3377 33.9322 35.8703 30.5625H42.0244H42.0191Z"
                      fill="var(--primary-color)"
                    />
                  </g>
                  <path
                    d="M19.07 42.969H17.216V42.204H21.896V42.969H20.051V48H19.07V42.969ZM22.6822 42.204H23.6632V44.724H26.4532V42.204H27.4342V48H26.4532V45.48H23.6632V48H22.6822V42.204ZM30.4969 42.042H31.4959L29.3899 48H28.3909L30.4969 42.042ZM32.4469 42.204H36.4879V42.969H33.4279V44.724H36.1549V45.48H33.4279V47.244H36.4879V48H32.4469V42.204ZM37.3951 42.204H38.2591L41.2831 46.47V42.204H42.2551V48H41.3911L38.3761 43.743V48H37.3951V42.204Z"
                    fill="var(--primary-color)"
                  />
                  <defs>
                    <clipPath id="clip0_4236_5179">
                      <rect
                        width="27"
                        height="27"
                        fill="white"
                        transform="translate(16 12)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </c-btn>
            </template>

            <v-list>
              <template v-for="lang of languageList" :key="'lang' + lang.id">
                <v-list-item @click="changeLang(lang.id)" link-class="px-3">
                  <div class="d-flex align-items-center px-3">
                    <span class="flag-lang mr-2"> {{ lang.image_url }} </span>
                    <span data-lang="profile">{{ lang.display_name }}</span>
                    <span v-if="lang.id == langs.lang" class="ml-auto">
                      <font-awesome-icon icon="check" />
                    </span>
                  </div>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </div>
      </div>
    </template>
  </template>
  <ModalLoading ref="modalLoading" />
</template>

<script>
import ModalLoading from "@/components/other/ModalLoading.vue";

export default {
  components: {
    ModalLoading
  },
  data() {
    return {
      langs: "",
      languageList: this.$store.state.languageList,
      showHeader: true
    };
  },
  props: {
    isShowing: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    hideLogoImg() {
      return this.$route.name == "profile";
    }
  },
  watch: {
    "$route.path"(val) {
      let lang = this.$cookies.get("lang");

      this.langs = lang;
    }
  },
  async created() {
    // this.lang =
    this.emitter.on("showHeader", () => this.toggleHeader(true));
    this.emitter.on("hideHeader", () => this.toggleHeader(false));
    if (
      this.$store.state.languageList.length == 0 &&
      this.$route.path == "/validatetelephone"
    ) {
      const res = await this.$store.dispatch("getLanguage");
      this.languageList = res;
    }
    if (this.$cookies.isKey("lang")) {
      let lang = this.$cookies.get("lang");
      this.langs = lang;
    }
  },
  mounted() {
    this.getLang();
  },

  methods: {
    toggleHeader(value) {
      let bodyStyles = document.body.style;
      if (!value) bodyStyles.setProperty("--padding-footer", "90px");
      else bodyStyles.setProperty("--padding-footer", "150px");
      this.showHeader = value;
    },
    async getLang() {
      if (this.$store.state.languageList.length == 0) {
        const res = await this.$store.dispatch("getLanguage");

        this.languageList = res;
      }
    },
    toProfile() {
      if (
        this.$route.path == "/register" ||
        this.$route.path == "/review" ||
        this.$route.path == "/validatetelephone" ||
        this.$config.line_layout == "Blank Theme"
      ) {
        return;
      }
      this.$router.push("/profile");
    },
    async changeLang(val) {
      this.$refs.modalLoading.show();
      let index = this.languageList.findIndex(el => el.id == val);

      let payload = {
        lang: this.languageList[index].id,
        name: this.languageList[index].name,
        flag: this.languageList[index].image_url
      };

      await this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          lang_id: String(this.languageList[index].id)
        }
      });
      await this.$cookies.set("lang", JSON.stringify(payload));
      this.langs = payload;
      await this.$getLang();
      await this.$store.dispatch("getProvince", false);
      await this.$store.dispatch("refreshUserProfile");
      this.$emit("updateView");

      this.$refs.modalLoading.hide();
    }
  }
};
</script>

<style lang="scss" scoped>
.bg-black {
  background-color: #000;
}

.btn-go-home {
  background-color: transparent;
  padding: 0;
  margin: 0;
  border: none;
}
#app-container.new-theme .navbar {
  box-shadow: unset !important;
}
.navbar {
  overflow: hidden;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 5;
  background-color: var(--theme-navigation-bar-color);
  transition: background-color 0.1s linear;
  box-shadow: 1px 1px 5px -3px black;
}
.navbar.blank {
  background-color: white !important;
}
.layout-1 {
  height: var(--header-height);
  .logo-img {
    width: auto;
    max-width: 200px;
    height: auto;
    max-height: 65px;
    margin: unset;
  }
}
.layout-2 {
  height: 70px;
  padding: 0 10px;
  .logo-img {
    width: auto;
    max-width: 200px;
    height: auto;
    max-height: 50px;
  }
}
.lang-icon {
  position: absolute;
  right: 5px;
  top: 50%;
  /* padding: 5px 5px; */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  .v-btn.v-btn--density-default {
    height: unset !important;
  }
  img,
  svg {
    vertical-align: middle;
    width: 60px;
    height: 60px;
    max-width: unset;
  }
}
.new-theme .lang-icon {
  // background: var(--theme-navigation-bar-color);
  z-index: 50;
}
.new-theme {
  .layout-1 {
    padding: 0;
    .logo-img {
      width: auto;
      max-width: 200px;
      height: auto;
      max-height: 65px;
    }
  }
}
</style>
